<template>
  <b-field
    :label="label"
    :type="hasError() ? 'is-danger' : ''"
    :message="errorMessage()"
    :class="{ required: required }"
  >
    <template v-if="hasInfo || isHtmlLabel" #label>
      <span v-if="isHtmlLabel" v-html="label" />
      <span v-else>
        {{ label }}
        <span>
          <b-tooltip
            type="is-light"
            :size="infoSize"
            :position="infoPosition"
            multilined
          >
            <i :class="infoIcon" />
            <template #content>
              <p v-if="infoType == 'text'">{{ info }}</p>
              <slot v-if="infoType == 'html'" name="info">
                <div v-html="info" />
              </slot>
            </template>
          </b-tooltip>
        </span>
      </span>
    </template>

    <b-input
      v-model="input"
      :type="type"
      :placeholder="placeholder"
      :icon="icon"
      :step="step"
      :rows="rows"
      :name="name"
      :disabled="disabled"
      :password-reveal="passwordReveal"
      :class="{ 'is-danger': hasError() }"
      @input="inputListener"
    />
  </b-field>
</template>

<script>
import InputBase from "./InputBase";

export default {
  extends: InputBase,
  props: {
    value: {
      required: true,
      validator() {
        return true;
      },
    },
    rows: {
      type: Number,
      default: undefined,
    },
    disabled: {
      type: Boolean,
    },
    icon: {
      default: undefined,
      type: String,
    },
    type: {
      default: "text",
      type: String,
    },
    step: {
      default() {
        if (this.type == "number") {
          return "0";
        }
        return undefined;
      },
      type: String,
    },
    passwordReveal: {
      default: false,
      type: Boolean,
    },
    required: {
      default: false,
      type: Boolean,
    },
    hasInfo: {
      default: false,
      type: Boolean,
    },
    infoIcon: {
      default: "mdi mdi-help-circle-outline",
      type: String,
    },
    info: {
      default: "",
      type: String,
    },
    infoPosition: {
      default: "is-top",
      type: String,
    },
    infoSize: {
      default: "is-medium",
      type: String,
    },
    infoType: {
      default: "text",
      type: String,
    },
    isHtmlLabel: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      input: this.value,
    };
  },
};
</script>
